<script setup lang="ts">
export interface ConfirmDialogOption {
  text: string
  onClick: () => any
  class?: string
}

const props = defineProps<{
  forceAnswer?: boolean
  options: ConfirmDialogOption[]
  title: string
  modalClasses?: string
  bodyClasses?: string
  headerClasses?: string
  footerClasses?: string
}>()

const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>

<template>
  <modal
    :force-answer="props.forceAnswer"
    :modal-classes="props.modalClasses"
    :body-classes="props.bodyClasses"
    :header-classes="props.headerClasses"
    :footer-classes="props.footerClasses"
    @close="close"
  >
    <template #header>
      {{ props.title }}
    </template>

    <template #body>
      <slot name="before" />

      <div class="tw-my-2 tw-flex tw-flex-col tw-gap-2">
        <InputAppButton
          v-for="(option, index) of props.options"
          :key="index"
          class="tw-w-full tw-flex-grow tw-text-center"
          :class="option.class"
          @click="option.onClick"
        >
          {{ option.text }}
        </InputAppButton>
      </div>

      <slot />
    </template>
  </modal>
</template>
